import React from 'react';
import { Alert, Row, Col } from 'antd';

interface ErrorMessagesProps {
  message: string;
}

const ErrorMessages = function ({ message }: ErrorMessagesProps) {
  if (!message) return null;

  return (
    <Row>
      <Col span={24} style={{ margin: '15px 0px' }}>
        <Alert
          message={message}
          type="error"
          showIcon
        />
      </Col>
    </Row>
  );
};

export default ErrorMessages;
